import { useEffect } from "react";
import Sidebar from "../../DesignSystem/Sidebar";
import { Helmet } from "react-helmet-async";
import UserApprovals from "./dashboard/Dashboard.jsx";
import "../../../../src/css/FinancialPromotions/FinancialPromotionsSubmission.css";
import { useUserRole } from "../../../context/UserRoleContext.js";
import { useNavigate } from "react-router-dom";

export default function AdminMediaPage() {
  const { userRole } = useUserRole();
  const navigate = useNavigate();
  
  // useEffect(() => {
  //   if (String(userRole || "").toLowerCase() !== "staff") {
  //     navigate("/MembersHub", { replace: true });
  //   }
  // }, [userRole, navigate]);
  return (
    <div className="fp-container">
      <Helmet>
        <title>Financial Promotions</title>
        <meta
          name="description"
          content="Admin page for uploading financial promotions for compliance review and approval."
        />
      </Helmet>
      <Sidebar />
      <UserApprovals />
    </div>
  );
}
